<template>
    <!-- section 1 -->
    <section class=" mx-auto flexmobile2 mt-6 md:mt-44 text-amber-50 px-20 container">
  <p class="text-amber-100 text-2xl md:text-3xl font-semibold pt-6">Defining User Tasks & Happy Path</p>
  <p class="text-white pt-6 md:pt-16 text-3xl dancing-script">Task 1</p>
  <p class="pt-6 text-lg ">
    You are a professional makeup artist (MUA) that wants to explore other professional brands to expand your makeup kit. Where would you go to find such brands? 
    <span class="text-amber-100">(Learning Task)</span>
  </p>
    </section>
    <!-- section 2 -->
    <section class="mx-auto flexmobile2 md:mt-24 text-amber-50 md:px-20 container">
  <div class="flex flexmobile2 items-center justify-between">
    <div class="flexmobile2 md:w-1/2">
      <h1 class="text-white text-2xl font-semibold -ml-6">Landing Page & Initial Menu Open</h1>
      <ol class="list-decimal pt-6 text-lg md:pt-16">
        <li>Press the Menu Icon to open the Menu.</li>
        <li class="pt-6 md:pt-12">The Menu is open; the user can begin to locate the appropriate Top Level category to initiate tasks.</li>
      </ol>
    </div>
    <div class="flexmobile2">
      <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726659698/Group_34210_pejakq.png" alt="Landing Page Example">
    </div>
  </div>
    </section>
    <!-- section 3 -->
    <section class="mx-auto flexmobile2 md:mt-44 text-amber-50 px-20 container">
  <div class="flex flexmobile2 items-center justify-between">
    <div class="flexmobile2 md:w-1/2">
      <h1 class="text-white text-2xl font-semibold -ml-6">Explore L'Oréal Brands</h1>
      <ol class="list-decimal pt-6 text-lg md:pt-16">
        <li class="pt-6">Access the Menu.</li>
        <li class="pt-6 md:pt-10">Select Brands & Products.</li>
        <li class="pt-6 md:pt-10">Choose a specific division.</li>
        <li class="pt-6 md:pt-10">Choose a Brand.</li>
      </ol>
    </div>
    <div class="flexmobile2">
      <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726659741/Group_34211_pbvfj3.png" alt="Explore L'Oréal Brands">
    </div>
  </div>
    </section>
    <!-- section 4 -->
    <section class="mx-auto flexmobile2 mt-10 md:mt-44 text-amber-50 px-20 container">
    <p class="text-white text-3xl dancing-script">Task 2</p>
    <p class="pt-6 text-lg md:pt-16">You believe makeup is a great way to express yourself. You feel that working with L'Oréal would be an opportunity to introduce creativity into your work. Where would you look to apply for a job with L'Oréal? (Business Interaction Task)</p>
    </section>
    <!-- section 5  -->
    <section class="mx-auto flexmobile2 mt-10 md:mt-28 text-amber-50 md:px-20 container">
   <div class="flex flexmobile2 items-center justify-between">
      <div class="md:w-1/2 -mt-12">
        <h1 class="text-white text-2xl font-semibold -ml-6">Job Openings: Part 1 <br> Finding Job Openings</h1>
        <ol class="pt-6 text-lg md:pt-16 list-decimal">
            <li class="pt-6 ">Access Menu.</li>
            <li class="pt-6 md:pt-10">Select Opportunities.</li>
            <li class="pt-6 md:pt-10">Select Careers.</li>
            <li class="pt-6 md:pt-10">Select Job Openings.</li>
        </ol>
     </div>
     <div class="flexmobile2">
        <img loading="lazy" class="md:w-full w-56" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726659779/Group_34212_p1chey.png" alt="">
     </div>
   </div>
    </section>
    <!-- section 6 -->
    <section class="mx-auto flexmobile2 md:mt-44 text-amber-50 md:px-20 container">
    <div class="flex flexmobile2 items-center justify-between">
      <div class="md:w-1/2">
        <h1 class="text-white text-2xl font-semibold -ml-6">Job Openings: Part 2 <br> Searching for Job Openings</h1>
        <ol class=" pt-6 text-lg md:pt-16 list-decimal">
            <li class="pt-6">Locate search bar for Job Openings.</li>
            <li class="pt-6 md:pt-10">Define search by job position interest.</li>
            <li class="pt-6 md:pt-10">Select Careers.</li>
            <li class="pt-6 md:pt-10">Press search.</li>
        </ol>
      </div>
      <div class="flexmobile2">
        <img loading="lazy" class="md:w-full w-56" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726659816/Group_34213_1_feijhc.png" alt="">
      </div>
    </div>
    </section>
    <!-- section 7 -->
    <section class="mx-auto flexmobile2 md:mt-44 text-amber-50 px-20 container">
   <div class=" flex flexmobile2 items-center justify-between">
      <div class=" md:w-1/2">
        <h1 class="text-white text-2xl font-semibold -ml-6">Job Openings: Part 3 <br>Fine-tuning Job Search Results</h1>
        <ol class=" pt-6 text-lg md:pt-16 list-decimal">
            <li class="pt-6 "  >Press “Sort” to open Sort menu and 
                choose how to Sort results.</li>
            <li class="pt-6 md:pt-10"> Show results.</li>
            <li class="pt-6 md:pt-10">Press “Filters” to open Filters menu and 
                choose how to Filter results.</li>
            <li class="pt-6 md:pt-10">  Show results.</li>
        </ol>
     </div>
     <div class=" flexmobile2">
        <img loading="lazy" class="md:w-full w-56" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726659895/Group_34214_1_skuduk.png" alt="">
     </div>
   </div>
    </section>
    <!-- section 8 -->
    <section class="mx-auto flexmobile2 md:mt-44 text-amber-50 px-20 container">
   <div class="flex flexmobile2 items-center justify-between">
      <div class="md:w-1/2">
        <h1 class="text-white text-2xl font-semibold -ml-6">Job Openings: Part 4 <br> Choose Job to Apply to</h1>
        <ol class=" pt-6 text-lg md:pt-16 list-decimal">
            <li class="pt-6">Choose which position to apply to.</li>
            <li class="pt-6 md:pt-10">Press “Apply Now” to be directed to job post.</li>
            <li class="pt-6 md:pt-10">Read Job Description.</li>
            <li class="pt-6 md:pt-10">Press “Apply Now” to apply to job position.</li>
        </ol>
     </div>
     <div>
        <img loading="lazy" class="md:w-full w-56" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726659931/Group_34216_1_wx0hvy.png" alt="">
     </div>
   </div>
    </section>

    <!-- section 9 -->
    <section class="mx-auto flexmobile2 mt-10 md:mt-44 text-amber-50 px-20 container">
    <p class="text-white text-3xl dancing-script">Task  3</p>
    <p class="pt-6 text-lg md:pt-10">Caring for the environment is important to you, and you'd like the products you use to do the same. Where would you go to learn about L'Oréal's commitments to the environment?</p>
    </section>
    <!-- section 10 -->
    <section class="mx-auto flexmobile2 mt-10 md:mt-24 text-amber-50 px-20 container">
   <div class=" flex flexmobile2 items-center justify-between">
      <div class=" md:w-1/2">
        <h1 class="text-white text-2xl font-semibold">Learn about L’Oréal 
            Eco-friendly Initiatives</h1>
        <ol class="pt-6 text-lg md:pt-16">
            <li class="pt-4"  >1. Access Menu.</li>
            <li class="pt-4 md:pt-10">2. Select Social Responsibility.</li>
            <li class="pt-4 md:pt-10">3. Select Fighting Climate Change.</li>
            <li class="pt-4 md:pt-10"> 4. Choose an initiative.</li>
        </ol>
     </div>
     <div class=" flexmobile2">
        <img loading="lazy" class=" flexmobile2" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726659976/Group_34217_n1kdod.png" alt="">
     </div>
   </div>
    </section>
    <!-- section 11 -->
    <section class="mx-auto flexmobile2 mt-10 md:mt-44 text-amber-50 px-20 container">
    <p class="text-amber-100 text-2xl md:text-3xl font-semibold pt-6">Tree Tests</p>
    <p class="text-white text-3xl dancing-script pt-6 md:pt-10">Pilot Tree Test</p>
    <p class="pt-6 text-lg md:pt-10">Only Task 1 and Task 2 were tested to get started.</p>
    </section>

    <!-- section 12 -->
    <section class="container  background-lor  mt-12 mx-auto md:px-20 ">
      <section class="w-full flex md:flex-col items-center justify-center transition-transform duration-500 ease-in-out">
        <section class="container  mx-auto md:px-20">
  <section class="w-full flex md:flex-col items-center justify-center transition-transform duration-500 ease-in-out">
    <section
      v-if="isVisible"
      class="w-full flex flex-col items-center justify-center text-center h-[90px] md:h-[300px] transition transform duration-500 ease-in-out"
      :class="{'opacity-0 scale-0': !inView, 'opacity-100 scale-100': inView}"
      ref="popupSection"
    >
    <div class="text-white text-center text-sm md:text-4xl">
        <p class="dancing-script mb-1 md:mb-6">Results </p>
        <div class="flex justify-between gap-20 dancing-script md:text-4xl text-white">
            <p class=" text-white md:text-3xl"><span class="dancing-script">Participants</span>  <span class=" montserrat font-bold">:3</span></p>
            <p class=" text-white md:text-3xl"><span class="dancing-script">Task 1</span> <br> <span class="montserrat font-bold"> 100% Success</span></p>
            <p class=" text-white md:text-3xl"><span class="dancing-script">Task 2</span> <br> <span class="montserrat font-bold">100% Success</span></p>
          </div>
        </div>
    </section>
  </section>
</section>


</section>

    </section>
    <!-- section 3  -->
    <section class="container flexmobile2 mt-8  mx-auto px-20 ">
    <div class="flex text-center gap-10 justify-between">
    <div>
      <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726660029/secreen01_zu61y4.png" alt="">
      <p class=" text-amber-50 pt-6 text-lg  dancing-script">Task 1 Analytics</p>
    </div>
    <div>
      <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726660071/screen02_yg5dvp.png" alt="">
      <p class=" text-amber-50 pt-6 text-lg dancing-script">Task 2 Analytics</p>
    </div>
    </div>
    </section>
    <!-- section 13 -->
    <section class="mx-auto flexmobile2 text-amber-50 mt-20 md:mt-56 px-20 container">
    <p class="text-white text-3xl dancing-script">Tree Test 1</p>
    <p class="pt-6 text-lg text-amber-100 md:pt-16">Included Pre Study Questions</p>
    <p class="pt-6 text-lg">It was important to see the <span class=" text-amber-100"> participant’s relationship with personal/cosmetics products</span>.
      Knowing this gives context to why the studies may not be as accurate as if the tests were given to the target audience.</p>
    <p class="pt-6 text-lg ">All of the three tasks were tested.</p>
    </section>

    <!-- section 14 -->
    <section class="container  background-lor flexmobile2 mt-8  mx-auto px-20 ">
    <section
      class=" w-full flexmobile2 flex justify-center text-center transition transform duration-500 ease-in-out"
      >
    <div class="text-white text-center text-sm md:text-4xl mt-16">
        <p class="dancing-script mb-1 md:mb-6">Results </p>
        <div class="flex justify-between gap-20 dancing-script md:text-4xl text-white mt-16">
            <p class=" text-white md:text-3xl mt-6"><span class="dancing-script">Participants</span><span class=" montserrat font-bold">:11</span></p>
            <p class=" text-white md:text-3xl"><span class="dancing-script">Task 1</span> <br> <span class="montserrat font-bold">91% Success</span></p>
            <p class=" text-white md:text-3xl"><span class="dancing-script">Task 2</span> <br> <span class="montserrat font-bold">91% Success</span></p>
            <p class=" text-white md:text-3xl"><span class="dancing-script">Task 3</span> <br> <span class="montserrat font-bold">55% Failure</span></p>
          </div>
        </div>
    </section>
    </section>
    <!-- section 15 -->
    <section class="md:container h-[400px] mt-8 mx-auto md:px-20">
    <div class="flex flexmobile2 text-center md:gap-10 justify-between">
        <div>
            <img loading="lazy"  src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726660099/first_q27jrh.png" alt="First Image">
            <p class=" text-amber-50 pt-6 text-lg dancing-script">Task 1 Analytics</p>
        </div>
        <div>
            <img  loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726660144/secound_uqlkjh.png" alt="Second Image">
            <p class=" text-amber-50 pt-6 text-lg dancing-script">Task 2 Analytics</p>
        </div>
        <div>
            <img  loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726660169/third_p89jhp.png" alt="Third Image">
            <p class=" text-amber-50 pt-6 text-lg dancing-script">Task 3 Analytics</p>
        </div>
    </div>
</section>

    <!-- section 16 -->
    <section class="mx-auto flexmobile2 md:mt-0 mt-56 text-amber-50 px-20 container">
    <p class="text-white text-3xl dancing-script">Pre Study Results</p>
    <p class="pt-6 text-lg ">1. Out of 11 participants, the <span class="text-amber-100">majority shopped for their own personal products,</span> one did not.</p>
    <p class="pt-6 text-lg ">2. Shopping ranged from <span class="text-amber-100">once or twice a week</span> to every six months.</p>
    <p class="pt-6 text-lg ">3. These participants are just <span class="text-amber-100">average consumers.</span> Knowing this, reflected that most of the participants are <span class="text-amber-100">familiar with the brand’s subject content.</span></p>
    <section class=" flex items-center flex-col justify-center">
      <div class="pt-10 md:text-center">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726660221/screen03_warwqh.png" alt="">
        <p class="text-amber-50 pt-6 text-lg  dancing-script">Task 1 - Pre Study Analytics</p>
    </div>
    <div class="pt-10 md:text-center">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726660231/screen04_lgpeb3.png" alt="">
        <p class="text-amber-50 pt-6 text-lg  dancing-script">Task 2 - Pre Study Analytics</p>
    </div>
    </section>
</section>

    <!-- section 17 -->
    <section class="mx-auto mt-20 flexmobile2 text-amber-50 px-20 container">
    <p class="text-white text-2xl md:text-3xl font-semibold pt-6">Changes Implemented for Tree Test 2:</p>
    <p class="pt-6 text-lg md:pt-16">1. Adjusted category name; changed  <span class="text-amber-100">“Safety Standards” to “Production Safety Measures”</span> to clearly state it concerns production.</p>
    <ul class="pt-6 text-lg md:pt-16">
      <li>2. Revised Task 3 to clearly state purpose of task.</li>
      <ol class=" list-disc">
        <li class="pt-6 text-lg  ml-10 text-amber-100">Task 3 Prompt: Caring for the environment is important to you, and you'd like the products you use to do the same. Where would you go to learn about L'Oréal's commitments to the environment? (Learning Task)</li>
      </ol>
      <li class="pt-6 text-lg md:pt-16">3. Additionally, revised Task 2 ; thought the question was leading, due to the word “opportunity” being in there, since that was the location of the answer. Changed to the phrase, “a good space” to test its success as a task.
      </li>
      <ol class=" list-disc">
        <li class="text-amber-100 pt-6 text-lg ml-10">Task 2 Prompt: You believe makeup is a great way to express yourself. You feel that working with L'Oréal would be a good space to introduce creativity into your work. Where would look to apply for a job with L'Oréal? (Business Interaction Task)</li>
      </ol>
    </ul>
    
  </section>
  <!-- section 18 -->
    <section class="container  background-lor flexmobile2   mx-auto px-20 mt-16">
    <section class=" w-full flexmobile2 flex justify-center text-center transition transform duration-500 ease-in-out">
    <div class="text-white text-center text-sm md:text-4xl mt-14">
        <p class="dancing-script mb-1 md:mb-6">Results </p>
        <div class="flex justify-between gap-20 dancing-script md:text-4xl mt-16 text-white">
            <p class=" text-white md:text-3xl mt-6"><span class="dancing-script">Participants</span><span class=" montserrat font-bold">:11</span></p>
            <p class=" text-white md:text-3xl"><span class="dancing-script">Task 1</span> <br> <span class="montserrat font-bold">100% Success</span></p>
            <p class=" text-white md:text-3xl"><span class="dancing-script">Task 2</span> <br> <span class="montserrat font-bold">100% Success</span></p>
            <p class=" text-white md:text-3xl"><span class="dancing-script">Task 3</span> <br> <span class="montserrat font-bold">53% Success</span></p>
          </div>
        </div>
    </section>
    </section>

    <!-- section 20 -->
    <section class="container flexmobile2 mt-8 mx-auto md:px-20 ">
    <div class="flex flexmobile2 dancing-script text-white text-xl text-center gap-10 justify-between">
    <div>
      <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726660316/onescreen_x5qqhm.png" alt="">
      <p class="text-amber-50 pt-6 text-lg  dancing-script">Task 1 Analytics</p>
    </div>
    <div>
      <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726660343/twoscreen_tczetr.png" alt="">
      <p class="text-amber-50 pt-6 text-lg  dancing-script">Task 2 Analytics</p>
    </div>
    <div>
      <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726660369/threescreen_nt7xj4.png" alt="">
      <p class="text-amber-50 pt-6 text-lg  dancing-script">Task 3 Analytics</p>
    </div>
    </div>
    </section>
    <!-- section 21 -->
   
</template>

<script>
export default{
    name:'LorealprojectThree',
    data() {
      return {
        inView: false, // Track if section 3 is in view
        isVisible: true // Control visibility of the section
      };
    },
    mounted() {
      // Initialize IntersectionObserver
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.inView = true; // Section is in view
          } else {
            this.inView = false; // Section is not in view
          }
        });
      });
  
      // Observe the section 3 element
      observer.observe(this.$refs.popupSection);
    }
}
</script>
<style>
 .background-lor{
    background-image: url("../assets/Group 34205.png");
    background-size:cover;
    width:1318px;
    height: 300px;
      
  }
  @media (max-width:740px) {
    .background-lor{
    background-image: url("../assets/Group 34205.png");
    background-size:contain;
    width:100%;
    height: 100%;
    background-repeat: no-repeat;
      
  }
  }
</style>